import { useMemo } from 'react'

import { InputSelect, type SelectProps } from './InputSelect'
import { useUserListContext } from '../../../hooks/context/useUserListContext'
import { RoleEnumType } from '@dpa/common/dist/prismaGenerated/inputTypeSchemas/RoleEnumSchema'

export function UserDropdownSelection({
  role,
  fieldId,
  strValue,
  setStrValue,
  saveStrValue,
}: { role?: RoleEnumType } & Omit<SelectProps, 'options'>) {
  const { allUserOptions, userById } = useUserListContext()
  const relevantUserOptions = useMemo(() => {
    if (role === undefined || allUserOptions === undefined) {
      return allUserOptions
    }
    const options = allUserOptions.filter(
      (user) =>
        user.roles === undefined ||
        -1 !== user.roles.findIndex((userRole) => userRole == role)
    )
    const currentUser = userById?.[Number(strValue)]

    if (
      currentUser == null ||
      options.some((option) => option.key === strValue)
    ) {
      return options
    }

    return [
      ...options,
      {
        key: strValue,
        value:
          currentUser.disabledAt == null
            ? `${currentUser.name} (mittlerweile andere interne Rolle)`
            : `${currentUser.name} (inaktiv)`,
        disabled: true,
      },
    ]
  }, [allUserOptions, role, strValue, userById])

  return (
    <InputSelect
      fieldId={fieldId}
      strValue={strValue}
      optionsWithKey={relevantUserOptions}
      setStrValue={setStrValue}
      saveStrValue={saveStrValue}
    />
  )
}
